import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ModelSettings from "./ModelSettings";
import CostControls from "./CostControls";
import APIKeyManager from "./APIKeyManager";
import UsageAlerts from "./UsageAlerts";
import { Settings, DollarSign, Key, Bell } from "lucide-react";

export default function AIConfigurationManager() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="border-primary/20 bg-gradient-to-br from-background to-primary/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Settings className="h-4 w-4 text-primary" />
              Model Settings
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Configure AI models and parameters
            </p>
          </CardContent>
        </Card>

        <Card className="border-warning/20 bg-gradient-to-br from-background to-warning/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <DollarSign className="h-4 w-4 text-warning" />
              Cost Controls
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Budget limits and rate controls
            </p>
          </CardContent>
        </Card>

        <Card className="border-success/20 bg-gradient-to-br from-background to-success/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Key className="h-4 w-4 text-success" />
              API Keys
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Manage and rotate API keys
            </p>
          </CardContent>
        </Card>

        <Card className="border-destructive/20 bg-gradient-to-br from-background to-destructive/5">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-sm">
              <Bell className="h-4 w-4 text-destructive" />
              Alerts
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-xs text-muted-foreground">
              Usage alerts and notifications
            </p>
          </CardContent>
        </Card>
      </div>

      <Tabs defaultValue="models" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="models" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Models
          </TabsTrigger>
          <TabsTrigger value="costs" className="flex items-center gap-2">
            <DollarSign className="h-4 w-4" />
            Costs
          </TabsTrigger>
          <TabsTrigger value="keys" className="flex items-center gap-2">
            <Key className="h-4 w-4" />
            API Keys
          </TabsTrigger>
          <TabsTrigger value="alerts" className="flex items-center gap-2">
            <Bell className="h-4 w-4" />
            Alerts
          </TabsTrigger>
        </TabsList>

        <TabsContent value="models" className="mt-6">
          <ModelSettings />
        </TabsContent>

        <TabsContent value="costs" className="mt-6">
          <CostControls />
        </TabsContent>

        <TabsContent value="keys" className="mt-6">
          <APIKeyManager />
        </TabsContent>

        <TabsContent value="alerts" className="mt-6">
          <UsageAlerts />
        </TabsContent>
      </Tabs>
    </div>
  );
}